$(document).ready(function() {
  $("#id_date, .dateinput").pickadate({
    format: "yyyy-mm-dd",
    formatSubmit: "yyyy-mm-dd",
    hiddenName: true
  });
});
